module.exports = __webpack_public_path__ + "static/media/social_youtube_gray.72d54b42.svg";